// st product-card-05.liquid 

$(document).ready(function() {
    // Function to update product title based on selected variant
    function updateProductTitle() {
        $('.card-swatch .swatch-label').on('click', function() {
            var $swatchLabel = $(this); // The clicked swatch label
            var variantValue = $swatchLabel.data('value'); // Get the variant value (e.g., '14kw', '14ky')
            var variantTitle = $swatchLabel.attr('title'); // Get the variant title (e.g., '14KW', '14KY')
// console.log('variantValue1'+ variantValue);
            // Find the associated product title
            var $titleLink = $swatchLabel.closest('.card-information__wrapper').find('.card-title-pr');
            var currentTitle = $titleLink.text().trim();

            // Check if the variant is already appended in the title
            var regex = /[-\s]?\w+(\d+[a-zA-Z]+)/; // Matches variant like "L" or "XL"
            if (regex.test(currentTitle)) {
                // Replace the existing variant text with the new one
                $titleLink.html(currentTitle.replace(regex, ' ' + variantTitle));
            } else {
                // If no variant is found in the title, append it
                $titleLink.html(currentTitle + ' - ' + variantTitle);
            }
 
            // Optionally, you can also update the URL to reflect the selected variant
            var variantId = $swatchLabel.data('variant-id');
            var productUrl = $titleLink.data('product-url') + '?variant=' + variantId;
            $titleLink.attr('href', productUrl);
        });

        // Update the title based on the default selected swatch on page load
        var $defaultSwatch = $('.card-swatch .swatch-label.is-active');
        if ($defaultSwatch.length) {
            var variantTitle = $defaultSwatch.attr('title'); // Get the title of the default selected variant
            var $titleLink = $defaultSwatch.closest('.card-information__wrapper').find('.card-title-pr');
            var currentTitle = $titleLink.text().trim();
// console.log('currentTitle'+ currentTitle);
         // Check if the variant is already appended in the title
            var regex = /[-\s]?\w+(\d+[a-zA-Z]+)/; // Matches variant like "L" or "XL"
            if (!regex.test(currentTitle)) {
                // If no variant is found in the title, append the default variant
              //  $titleLink.html(currentTitle + ' - ' + variantTitle);
            }
        }
    }

    // Initialize the title update function
    updateProductTitle();
});
// end 

// main-cart.liquid  <script src="{{ 'product-title-change-variant-select.js' | asset_url }}" type="text/javascript"></script>
$(document).ready(function() {
    // Loop through each cart item
    $('.cart-item').each(function() {
        var $cartItem = $(this);
         var metal = "";  
               $cartItem.find('.cart-item-variant').each(function() {
            var optionText = $(this).text();  
            if (optionText.includes("Metal")) {
                var regex = /\d+[a-zA-Z]+/;
                var match = optionText.match(regex);
                if (match) {
                    metal = match[0];  
                }
            }
        });
      if (metal) {
            var $productTitle = $cartItem.find('.cart-item-name .PR-text');
            var currentTitle = $productTitle.text();  // Get the current product title text

            // Replace the metal value in the product title (or append it if it doesn't exist)
            var regex = /\d+[a-zA-Z]+/;  // Match existing metal values like 10KR, 15KW, etc.
            if (regex.test(currentTitle)) {
                // If there's an existing metal value, replace it
                $productTitle.text(currentTitle.replace(regex, metal));
            } else {
                // If there's no metal value in the title, prepend the metal value
                $productTitle.text(metal + ' ' + currentTitle);
            }
        }
    });
});
// end 

//snippets%2Fhalo-quick-view.liquid
